export default "__VITE_ASSET__Fa_RwtGP__"